import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

// Aperçu d'une diapo telle qu'elle sortira (rendu serveur, valeurs non enregistrées), rafraîchi après chaque modification
export const ApercuDiapo = ({ api, cle, numero, valeur, refs, cadrages, className = '' }) => {
  const [url, setUrl] = useState(null);
  const [charge, setCharge] = useState(false);
  const minuteur = useRef(null);
  const corps = JSON.stringify({ cle, numero, diapo: valeur, photos: refs, cadrages });
  useEffect(() => {
    clearTimeout(minuteur.current);
    minuteur.current = setTimeout(async () => {
      setCharge(true);
      try {
        const { data } = await axios.post(`${api}/apercu`, JSON.parse(corps), { responseType: 'blob' });
        setUrl((ancien) => { if (ancien) URL.revokeObjectURL(ancien); return URL.createObjectURL(data); });
      } catch { /* aperçu indisponible : on garde le précédent */ }
      finally { setCharge(false); }
    }, 700);
    return () => clearTimeout(minuteur.current);
  }, [api, corps]);
  return (
    <div className={`relative overflow-hidden rounded-lg border border-slate-200 bg-slate-100 ${className}`} style={{ aspectRatio: '16 / 9' }}
      data-testid={`presentation-apercu-${cle}`}>
      {url && <img src={url} alt="Aperçu de la diapositive" className="h-full w-full object-contain" />}
      {charge && <span className="absolute right-2 top-2 rounded-full bg-white/90 p-1.5 shadow"><Loader2 className="h-4 w-4 animate-spin text-[#0F172A]" /></span>}
    </div>
  );
};
